import { Button, Card, Chip, Spinner, Typography } from '@material-tailwind/react';
import React, { useEffect, useState } from 'react'
import { useShared } from '../../hooks/useShared';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs';
import AInput from '../../components/fields/AInput';
import ASelect from '../../components/fields/ASelect';
import APDate from '../../components/fields/APDate';
import ASpinner from '../../components/partials/ASpinner';
import CustomItemsFields from './CustomItemsFields';
import { useParams } from 'react-router-dom';
import AIcon from '../../components/partials/AIcon';

const breadcrumbs = [{ name: 'اينوايس‌ها', link: '/invoices/0' }, { name: 'اينوايس جديد', link: null },]

const inputFields = {
    invoice_type: {
        label: 'نوع اينوايس', name: 'invoice_type', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'Please select a invoice type.', hide: true,
        options: [
            { value: 1, label: 'صادرات' },
            { value: 2, label: 'واردات' },
        ]
    },
    company_inovice_number: { label: 'نمبر اينوايس', name: 'company_inovice_number', type: 'text', roles: [1], icon: 'text-outline', className: '', required: "Please enter invoice number.", options: [] },
    tariff: { label: 'تعــرفه', name: 'invoice_tariff', type: 'select', roles: [1], icon: 'text-outline', className: '', required: "Please select Tariff.", options: [] },
    company: { label: 'شــرکت', name: 'from', type: 'select', roles: [1], icon: 'text-outline', className: '', required: "Please select a company.", options: [] },

    items: {
        label: 'اجناس', name: 'items', type: 'items_comp', roles: [1], icon: 'text-outline', className: '', required: true,
        options: { head: ["(Item) جنس", '(SQM) متراژ', "(Remarks) توضیح", "نرخ در اينوايس فی متر", " (Weight KG) وزن", "(Sort) سورت", "(Pieces) قطعه", "(Bales) بندل"], fields: { category: null, quantity: null, description: null, price_per_unit: null, weight: null, sort: null, pieces: null, bales: null } },
    },
    currency: {
        label: 'واحد پولی', name: 'currency', type: 'select', roles: [1], icon: 'book-outline', className: '', required: "Please select a currency.",
        options: []
    },

    export_type: {
        label: 'طريق صدور', name: 'export_type', type: 'select', roles: [1], icon: 'book-outline', className: '', required: 'Please enter export way.',
        options: []
    },
    transit_via: { label: 'Through (Transit Via)', name: 'transit_via', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false, note: 'Example: From Kabul International AIRPORT To UAE Transit To China' },
    description: { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false },



    ship_to: [

        { label: 'اسم مشتری', name: 'shipping_name', type: 'text', roles: [1], icon: 'text-outline', className: 'col-span-3 md:col-span-2', required: "Customer name is required.", },
        { label: 'تاريخ صدور', name: 'shipping_date', type: 'pdate', roles: [1], icon: 'text-outline', className: 'col-span-3 md:col-span-1', required: "Shipping date is required.", },
        { label: 'ادرس', name: 'shipping_address', type: 'text', roles: [1], icon: 'text-outline', className: 'col-span-3', required: false, },
        { label: 'شهر/ ولايت', name: 'shipping_city', type: 'text', roles: [1], icon: 'text-outline', className: 'col-span-3 md:col-span-1', required: "Shipping city is required.", },
        { label: 'کشور', name: 'shipping_state', type: 'select', roles: [1], icon: 'text-outline', className: 'col-span-3 md:col-span-1', required: "Shipping country is required.", options: [] },
        { label: 'زيپ کود', name: 'shipping_zip', type: 'text', roles: [1], icon: 'text-outline', className: 'col-span-3 md:col-span-1', required: false, },
        { label: 'شماره تماس', name: 'shipping_phone', type: 'text', roles: [1], icon: 'text-outline', className: 'col-span-3  md:col-span-1', required: false, note: "Separate multiple numbers by comma, dash, hyphen or slash" },
        { label: 'ایميل ادرس', name: 'shipping_email', type: 'email', roles: [1], icon: 'text-outline', className: 'col-span-3  md:col-span-2', required: false },
    ]
}



export default function NewInvoice() {

    const { http, auth, com, setModel, navigate, setMessage, fetchModelCounts, setCountries, funs } = useShared();
    useEffect(() => {
        if (!auth.hasRole([1, 2, 4, 18])) {
            return navigate("/db/notAllowed")
        }
    }, [])

    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [invoiceType, setInvoiceType] = useState({ value: 1, label: 'صادرات' })
    const [tarifInput, setTarifInput] = useState({ ...inputFields.tariff })
    const [companyInput, setCompanyInput] = useState({ ...inputFields.company })
    const [currencyInput, setCurrencyInput] = useState({ ...inputFields.currency })
    const [exportTypes, setExportTypes] = useState({ ...inputFields.export_type })
    const [items, setItems] = useState([])
    const [ciNumber, setCiNumber] = useState(null)
    const { id } = useParams();

    const { register, handleSubmit, control, formState: { errors }, reset, setValue } = useForm({});


    //get Invoice by Id
    useEffect(() => {
        if (id > 0) {
            setModel(null)
            setLoading(true)
            http.get(`/api/invoices/${id}`).then(res => {
                console.log('get model ', res);
                if (res.data.success && res.data.data) {
                    const data = res.data.data;
                    data['shipping_date'] = com.dateConvert(data["shipping_date"], false) // convert miladi to shamsi date
                    reset(data)

                    getcurrencies()
                    getExportPorts()
                    invoiceCompanyChange(data?.from)
                    setValue("items", data?.tariff?.items)
                    setItems(data?.tariff?.items)

                }
                setLoading(false)
            }, err => {
                console.log('err');
                setLoading(true)
            })
        } else {
            setValue("currency", { "value": 12, "label": "USD", "name": "USD" });
            setValue("invoice_type", invoiceType)

        }
        getCompanyies()
        getExportPorts()

    }, [])


    //get all companies
    const getCompanyies = () => {
        console.log("getCompanyies ")

        if (companyInput.options?.length === 0) {
            setLoading(true)
            //Normal User
            if (auth.hasRole([4])) {
                http.get(`/api/companies?uId=${auth?.getUserID()}`).then(res => {
                    console.log('get companies normaal user', res);
                    if (res.data.success) {

                        if (res?.data?.data?.length > 0) {
                            // setCompanyInput(pre=>({...pre, isDisabled:true, options:res.data.data}))
                            setValue("company", res?.data?.data[0])
                            // setCompanyInput(pre => ({ ...pre, options: res.data.data }))
                            invoiceCompanyChange(res?.data?.data[0])
                            setLoading(false)
                        } else {
                            setErrorMessage("شما شرکت خود را در ديتابيس ثبت نکرده اید. لطفا اول آن را ثبت کنید.")
                            setLoading(false)
                        }

                    }
                })
            }
            else if (auth.hasRole([1, 2, 18])) {
                http.get(`/api/companies?nameId=true`).then(res => {
                    console.log('get companies ', res);
                    if (res.data.success) {
                        //  inputFields.company.options = res.data.data
                        setCompanyInput(pre => ({ ...pre, options: res.data.data }))
                    }
                    setLoading(false)
                })
            }
        }
    }


    //get currencies
    const getcurrencies = () => {
        http.post(`/api/categoryAdvanceSearch?name=Currency`).then(res => {
            console.log('get currencies ', res);
            if (res.data.success) {
                setCurrencyInput(pre => ({ ...pre, options: res.data.data }))
            }
        })
    }


    //Get Export Ports
    const getExportPorts = (id) => {
        setLoading(true)
        http.post(`/api/categoryAdvanceSearch?typeId=${57}`).then(res => {
            console.log(id, 'get getExportPorts ', res);
            if (res.data.success) {
                setExportTypes(pre => ({ ...pre, options: res.data.data }))
                setLoading(false)
            }
        }, err => {
            setLoading(false)
            console.log('getExportPorts error ', err);
        })

    }



    //get tariffs
    const getTriffs = (cId) => {
        http.post(`/api/tariffsAdvanceSearch`, { company_id: cId, tariff_type: 21 }).then(res => {
            console.log(cId, 'get tariffs ', res);
            if (res.data.success) {
                //  tariff.options = res.data.data
                const data = res.data.data
                if (data?.length > 0) {
                    setTarifInput(pre => ({ ...pre, options: res.data.data }))
                    getcurrencies();
                } else {
                    setErrorMessage(`لطفا اولا برای اقلام صادراتی خود تعرفه بسازيد !`)
                }

            }
        })
    }


    //get previous invoice company number
    const getPreviousInvoiceCompanyNumber = (iId) => {
        http.post(`/api/invoicesAdvanceSearch`, { company_id: iId, type: 'previousInvoiceNumber' }).then(res => {
            console.log(iId, 'getPreviousInvoiceCompanyNumber ', res);
            if (res.data.success) {
                setCiNumber(res?.data?.data?.company_inovice_number)

            }
        })
    }



    useEffect(() => {
        // setCountries().sort((a, b) => a.label.localeCompare(b.label));
        if (inputFields?.ship_to[4]?.options?.length === 0)
            inputFields.ship_to[4].options = setCountries()
    }, [])


    const mReset = () => {
        reset({})
    }


    const submit = async (submitData) => {

        console.log("submit", submitData);
        setErrorMessage(null)
        funs?.getBla();
        const bla = funs?.bla;
        if (bla && (bla?.err?.status === 1 || bla.actions?.status === 1)) {
        console.log(bla);
        if (bla?.err?.status === 1) {
            setErrorMessage(bla?.err?.msg);
            toast.error(bla?.err?.msg);
        }
        } else {

        try {
            submitData["shipping_date"] = com.dateConvert(submitData["shipping_date"]) // convert shamsi to miladi date
            setLoading(true)
            const res = await http.post(`api/${'invoices'}`, submitData);

            console.log('model  ', res);

            if (res.data?.success) {
                const invoice = res.data?.data;
                // upload image if exists
                setLoading(false)
                toast.success(res.data.message);
                setMessage(res.data.message)
                fetchModelCounts()
                navigate(-1)

            }
        } catch (error) {
            console.log(error);
            setLoading(false)
            const err = error?.response?.data

            if (!err?.success) {
                setErrorMessage(err?.message)
                toast.error(err?.message);
            }
        }
    }
        return false
    }





    /*  const invoiceTypeChange = (e) => {
         console.log(e);
         setValue("invoice_type", e)
         setInvoiceType(e)
         getCompanyies();
     }
  */
    const invoiceCompanyChange = (e) => {
        console.log("invoiceCompanyChange", e);
        setValue("from", e)
        if (e) {
            getTriffs(e?.value)
            getPreviousInvoiceCompanyNumber(e?.value)
        }

    }

    const tarifChange = (e) => {
        console.log('tarifChange', e);
        setValue("invoice_tariff", { value: e?.value, label: e?.label })
        let items = [];
        e?.items?.map((it, i) => {
            items.push({
                category: it?.category,
                quantity: it?.quantity,
                price_per_unit: it?.price_per_unit,
                quantity_type: it?.quantity_type,
                id: it?.id
            })
        })
        setItems(items)
        setValue("items", items)

        console.log(items);
    }


    const from = () => {
        return <> {companyInput?.options?.length > 0 && <fieldset className='border p-3 rounded-lg grid gap-4 border-green-800 my-4 border-dashed ' >
            <legend className='font-semibold text-green-800 md:text-xl'> {invoiceType?.value === 1 ? 'From' : 'Ship To'} </legend>
            <ASelect v={{ register, errors, control, data: companyInput }} onChange={invoiceCompanyChange} />
        </fieldset>}
            {id == 0 && ciNumber && <div className='flex font-bold'>نمبر اينوايس قبلی : <Chip variant="ghost" size="sm" color="green" value={ciNumber} /> </div>}
            <AInput v={{ register, errors, data: inputFields?.company_inovice_number }} />

            {tarifInput?.options?.length > 0 && <ASelect v={{ register, errors, control, data: tarifInput }} onChange={tarifChange} />}
            {items?.length > 0 && <CustomItemsFields v={{ register, errors, control, data: inputFields?.items?.options, items: 'items' }} />}
            {currencyInput?.options?.length > 0 && <ASelect v={{ register, errors, control, data: currencyInput }} />}

        </>
    }

    const shipTo = () => {
        return <> {tarifInput?.options.length > 0 &&
            <fieldset className=' p-3 rounded-lg grid gap-4 grid-cols-1 md:grid-cols-3 my-4 border border-dashed border-purple-500' >
                <legend className='font-semibold text-purple-500  md:text-xl'> {invoiceType?.value === 2 ? 'From' : 'Ship To'} </legend>

                {inputFields.ship_to?.map((data, i) => {

                    return (<React.Fragment key={i}>{
                        data?.type === 'text' || data.type === 'date' || data?.type === 'textarea' || data?.type === 'number' || data?.type === 'email' ?
                            <AInput v={{ register, errors, data }} />
                            : data?.type === 'select' ? <ASelect v={{ register, errors, control, data }} />
                                : data?.type === 'pdate' ? <APDate v={{ register, errors, control, setValue, data }} />
                                    : null
                    }</React.Fragment>)
                })}
            </fieldset>}</>

    }


    return (
        <>
            <ABreadcrumbs links={breadcrumbs} />

            <div className='md:flex  items-start gap-4' dir='ltr'>

                <Card className="w-full p-2 md:p-4 mt-4 relative">

                    <p className="text-sm text-main-color font-bold capitalize">معلومات اينوايس جديد</p>
                    <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>
                        {loading && <ASpinner />}

                        <div className='grid md:grid-cols-1 gap-4'>
                            <ASelect v={{ register, errors, control, data: inputFields.invoice_type }} />
                            <ASelect v={{ register, errors, control, data: exportTypes }} />
                            {invoiceType?.value === 1 && <>{from()}  {shipTo()}</>}
                            {invoiceType?.value === 2 && <>{shipTo()} {from()} </>}



                            <AInput v={{ register, errors, data: inputFields.transit_via }} />
                            <AInput v={{ register, errors, data: inputFields.description }} />
                        </div>



                        {errorMessage && <Typography
                            style={{ direction: 'rtl' }}
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal text-base"
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}
                        <div className='flex gap-4 md:justify-start'>
                            <Button className="btn1 w-full md:w-[10%] amiriB text-white text-base" size='sm' type="submit"
                                disabled={loading || (tarifInput?.options?.length === 0)}>
                                {loading ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}    </Button>
                            <Button variant="outlined" size='sm' color="gray" onClick={() => mReset()}>Reset</Button>
                        </div>
                    </form>
                </Card>
            </div>
            <ToastContainer />
        </>
    )
}
